import { XIcon } from "@heroicons/react/solid";

interface FilterPillProps {
  label: string;
  onRemove: () => void;
}

const FilterPill = ({ label, onRemove }: FilterPillProps) => (
  <span className="flex items-center bg-gray-100 px-2 py-1 rounded text-sm text-gray-700">
    {label}
    <XIcon
      className="h-4 w-4 ml-1 cursor-pointer text-gray-500 hover:text-gray-700"
      onClick={onRemove}
    />
  </span>
);

export default FilterPill;
